<div class="row">
  <div class="col-10">
    <h3 class="description mb-0">
      {{apiInfo?.displayName}} API Configuration
    </h3>
    <div>
      <small>
        <span>
          {{apiInfo?.shortDescription}}
        </span>
      </small>
    </div>

    <div class="alert alert-info alert-with-icon alert-dismissible fade show" data-notify="container">
      <button type="button" aria-hidden="true" class="close" data-dismiss="alert" aria-label="Close">
        <i class="nc-icon nc-simple-remove"></i>
      </button>
      <span data-notify="icon" [ngClass]="apiInfo?.displayIcon"></span>
      <span data-notify="message" [innerHtml]="apiInfo?.fullDescription"></span>
    </div>

  </div>
  <div class="col-2 text-right">
    <button (click)="onAddNewProject();" class="btn btn-sm btn-outline-info btn-round btn-icon"><i class="nc-icon nc-simple-add"></i></button>
  </div>
</div>
<hr/>

<app-emailproject [currentProject]="p" [currentApiId]="apiInfo?.id" *ngFor="let p of projects"></app-emailproject>

<app-addnewemail></app-addnewemail>
<app-emailTemplate></app-emailTemplate>